<!-- @format -->

<template>
	<div style="border: 1px solid #f3f4f8">
		<div v-if="toolbars" ref="toolbar" class="pc-tree-toolbar">
			<span style="line-height: 30px"> 请选择岗位选择器 </span>
			<el-dropdown size="default" class="platform-fr">
				<el-button :class="['layout-header--' + 'large']" icon="MoreFilled" size="small" style="border-radius: 5px" />
				<template #dropdown>
					<el-dropdown-menu class="ibps-table-dropdown-menu">
						<pc-toolbar :actions="toolbars" :type="'menu'" @action-event="handleTreeAction" />
					</el-dropdown-menu>
				</template>
			</el-dropdown>
		</div>
		<div :style="{ height: tableHeight + 'px' }">
			<el-scrollbar style="height: 100%" wrap-class="pc-tree-wrapper ibps-scrollbar-wrapper">
				<!-- 多选-->
				<!-- @node-click="handleCheckChange" -->
				<!-- @check-change="handleCheckChange" -->
				<el-tree
					v-if="multiple"
					ref="elTree"
					v-loading="loading"
					:data="treeData"
					:expand-on-click-node="false"
					:props="{ children: 'children', label: 'name', isLeaf: 'leaf' }"
					:load="loadTreeNode"
					:lazy="lazyTree"
					:show-checkbox="multiple"
					:check-strictly="true"
					:filter-node-method="filterNode"
					:node-key="nodeKey"
					pid-key="parentId"
					:default-expanded-keys="refreshData"
					:default-expand-all="defaultExpandAll"
					:default-checked-keys="defaultCheckedKeys"
					highlight-current
					check-on-click-node
					@check-change="handleCheckChange"
				>
					<template #default="{ node }">
						<span style="width: 100%">
							<el-tooltip
								effect="dark"
								:enterable="false"
								:content="node.label"
								placement="top"
								:disabled="nodeWidth(node) >= stringWidth(node)"
							>
								<span> {{ node.label }} </span>
							</el-tooltip>
						</span>
					</template>
				</el-tree>
				<!-- 单选-->
				<el-tree
					v-else
					ref="elTree"
					v-loading="loading"
					:data="treeData"
					:expand-on-click-node="false"
					:props="{ children: 'children', label: 'name', isLeaf: 'leaf' }"
					:load="loadTreeNode"
					:lazy="lazyTree"
					:node-key="nodeKey"
					pid-key="parentId"
					:default-expanded-keys="refreshData"
					:default-expand-all="defaultExpandAll"
					highlight-current
					:show-checkbox="multiple"
					@node-click="onNodeClick"
				>
					<template #default="{ node, data }">
						<span class="custom-tree-node">
							<el-radio v-model="radio" :label="data[pkKey]" :disabled="data.disabled" @change="changeRadio(data)">{{
								node.label
							}}</el-radio>
						</span>
					</template>
				</el-tree>
			</el-scrollbar>
		</div>
	</div>
</template>
<script>
	import TreeLazyEvens from './mixins/TreeLazyEvens';
	import { TreeUtils } from '@/utils/tree';
	import { $utils } from '@/utils/publicUtils';
	import { PcToolbar } from '@/components/pc-toolbar/index';

	export default {
		components: { PcToolbar },
		mixins: [TreeLazyEvens],
		props: {
			formData: [Object, Array], // 所有字段数据,(包含主主子表)
			value: [Object, Array],
			multiple: Boolean,
			height: {
				type: String,
				default: '400px',
			},
			nodeKey: {
				type: String,
				default: 'id',
			},
			pkKey: {
				type: String,
				default: 'id',
			},
			refreshData: {
				type: Array,
				default: () => ['0'],
			},
			partyTypeId: {
				// 类型节点ID
				type: [String, Number],
				default: '',
			},
			currentOrgId: {
				// 用户组ID
				type: [String, Number],
				default: '',
			},
			script: String,
			isUseScope: {
				// 是否启用范围
				type: Boolean,
				default: false,
			},
			partyType: {
				// 类型节点ID
				type: String,
				default: 'position',
			},
			hasSubset: {
				// 是否包含子集
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				defaultCheckedKeys: [],
				parentId: '0',
				defaultExpandAll: true,
				lazyTree: true,
				moreSearchParams: {},

				radio: '',
				loading: false,
				dialogFormVisible: false,
				filterText: '',
				// 树配置
				treeData: [],
				toolbars: [
					{
						key: 'refresh',
						label: '刷新',
					},
					{
						key: 'expand',
						label: '展开',
					},
					{
						key: 'compress',
						label: '收缩',
					},
				],
			};
		},
		computed: {
			tableHeight() {
				const h = this.height.substr(0, this.height.length - 2);
				return parseInt(h) - 10;
			},
			nodeWidth() {
				return (node) => {
					return 540 - 24 * node.level - 24;
				};
			},
			stringWidth() {
				return (node) => {
					return this.getTextWidth(node.label);
				};
			},
		},
		watch: {
			filterText(val) {
				this.$refs.elTree.filter(val);
			},
		},
		mounted() {
			if (this.pkKey === 'id') {
				if ($utils.isNotEmpty(this.value)) {
					if (this.multiple) {
						const temp = [];
						this.defaultCheckedKeys = this.getDefaultCheckByValue(this.value, temp, this.nodeKey);
					} else {
						let temp = [];
						temp = this.getDefaultCheckByValue(this.value, temp, this.pkKey);
						if ($utils.isNotEmpty(temp)) {
							this.radio = temp[0] || '';
						}
					}
				} else {
					this.defaultCheckedKeys = [];
				}
			}
		},
		beforeUnmount() {
			this.defaultCheckedKeys = null;
			this.moreSearchParams = null;
			this.treeData = null;
			this.toolbars = null;
		},
		methods: {
			getDefaultCheckByValue(item, data, key) {
				if ($utils.isEmpty(item)) return data;
				if ($utils.isObject(item) && $utils.isNotEmpty(item[key])) {
					data.push(item[key]);
					return data;
				}
				item.forEach((el) => {
					if ($utils.isArray(el)) {
						this.getDefaultCheckByValue(el, data, key);
					} else if ($utils.isObject(el) && $utils.isNotEmpty(el[key])) {
						data.push(el[key]);
					}
				});
				return data;
			},
			setChecked(data, selected) {
				// 备注: 修改不是多选时移除标签有误的问题
				if (data !== undefined && this.multiple) {
					this.$refs.elTree.setChecked(data, selected);
				} else {
					this.radio = '';
				}
			},
			cleanData(multiple) {
				if (multiple) {
					this.$refs.elTree.setCheckedKeys([]);
				} else {
					this.radio = '';
				}
			},
			// 加载岗位树
			loadTreeNode(node, resolve) {
				this.loading = true;
				const moreSearchParams = this.moreSearchParams;
				const hasSubset = this.hasSubset;
				const type = this.partyTypeId !== '' ? this.partyTypeId : '1';
				if (this.isUseScope) {
					if (type === 'script') {
						this.getScriptData(this.script);
						this.loading = false;
						return;
					}
					const partyId = this.currentOrgId;
					this.findTreeDataTypes(type, { node, partyId, moreSearchParams, hasSubset })
						.then((res) => {
							resolve(res);
							this.loading = false;
						})
						.catch(() => {
							this.loading = false;
							resolve([]);
						});
				} else {
					this.findTreeDataTypes(type, { node, moreSearchParams })
						.then((res) => {
							resolve(res);
							this.loading = false;
						})
						.catch(() => {
							this.loading = false;
							resolve([]);
						});
				}
			},
			toTree(data) {
				if ($utils.isNotEmpty(data)) {
					for (let i = 0; i < data.length; i++) {
						if (data[i].id === '0' || data[i].id === 0) {
							data[i].disabled = true;
						}
					}
				}
				return TreeUtils.transformToTreeFormat(data, {
					idKey: 'id',
					pIdKey: 'parentId',
					childrenKey: 'children',
				});
			},
			// 根据渲染的数据范围类型，筛选目标节点
			filterTreeChildren(treeData, treeScope) {
				const data = [];
				// 返回设置的范围节点
				if (treeScope === 'root') {
					const currentOrgIds = this.currentOrgId.split(',');
					treeData.forEach((f) => {
						if (currentOrgIds.includes(f.id)) {
							f.leaf = !this.hasSubset;
							data.push(f);
						}
					});
				}
				return data;
			},
			// 脚本函数
			getScriptData(scriptValue) {
				const dynamicValue = FormUtils.getCalDynamicValue(scriptValue, this.formData);
				dynamicValue.then((response) => {
					const data = JSON.parse(response);
					this.treeData = TreeUtils.transformToTreeFormat(data);
				});
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.name.indexOf(value) !== -1;
			},
			// 处理更多查询弹窗
			handleMoreSearch() {
				this.dialogFormVisible = true;
			},
			// 更多查询
			handleMoreSearchAction(data) {
				this.loading = true;
				this.moreSearchParams = data;
				getTreeData(data)
					.then((response) => {
						const data = response.data;
						this.treeData = TreeUtils.transformToTreeFormat(data);
						this.loading = false;
					})
					.catch(() => {
						this.loading = false;
					});
			},
			// 查询
			search() {
				const node = this.$refs.elTree.getNode(this.parentId); // 通过节点id找到对应树节点对象
				if (node) {
					node.loaded = false;
					node.expand();
				}
			},
			refreshTree() {
				this.parentId = '0';
				this.search();
			},
			// 重置查询条件
			reset() {
				this.$refs.crud.handleReset();
			},
			handleTreeAction(action, position) {
				const command = action.key;
				if (position === 'toolbar' && command === 'refresh') {
					this.refreshTree();
				}
				if (command === 'expand') {
					this.expandCompressTree(true);
				} else if (command === 'compress') {
					this.expandCompressTree(false);
				}
			},
			expandCompressTree(expanded) {
				for (let i = 0; i < this.$refs.elTree.store._getAllNodes().length; i++) {
					this.$refs.elTree.store._getAllNodes()[i].expanded = expanded;
				}
			},
			handleCheckChange(data, checked) {
				if (data.id === 0 || data.id === '0') return;
				// let val = JSON.parse(JSON.stringify(this.value))
				let val = JSON.parse(JSON.stringify(this.$refs.elTree.getCheckedNodes()));
				if (checked) {
					const index = val.find((v) => {
						return v[this.pkKey] === data[this.pkKey];
					});
					if (!index) {
						val.push(data);
					}
				} else {
					val = val.filter((v) => {
						return v[this.pkKey] !== data[this.pkKey];
					});
				}
				this.$emit('selected', val);
			},
			changeRadio(data) {
				if (data.id === 0 || data.id === '0') return;
				this.$emit('selected', data);
			},
			onNodeClick(data) {
				this.radio = data[this.pkKey];
				this.$emit('selected', data);
			},
			// 获取字符串长度
			getTextWidth(str) {
				const dom = document.createElement('span');
				dom.style.display = 'inline-block';
				dom.textContent = str;
				document.body.appendChild(dom);
				const width = dom.offsetWidth;
				document.body.removeChild(dom);
				return width;
			},
		},
	};
</script>
<style lang="scss" scoped>
	$border-color: #e5e6e7;

	.pc-tree-toolbar {
		background-color: #f3f4f8;
		height: 30px;
		padding: 5px 10px;
	}

	// .ibps-tree-search-form {
	// 	padding: 5px;
	// 	border-right: 1px solid $border-color;
	// 	background: #ffffff;
	// }

	// .ibps-tree-main {
	// 	border: 1px solid $border-color;
	// }

	.pc-tree-wrapper {
		background: #ffffff;

		.el-tree > .el-tree-node {
			display: inline-block;
		}
	}
</style>
